import { createContext } from 'react';
import { Configuration } from '../interfaces';

export const ConfigurationContext = createContext<Configuration>(null);
